(function () {
  // 同一 src はセクションの配置数ぶん評価される
  if (window.cSliderCardsSkeletonBound) return;
  window.cSliderCardsSkeletonBound = true;

  const IMAGE_SELECTOR = '.c_c-slider-cards__img';

  function markLoaded(img) {
    const media = img.closest('.c_c-slider-cards__media');
    if (media) media.classList.add('is-loaded');
  }

  function sweep() {
    document.querySelectorAll(IMAGE_SELECTOR).forEach((img) => {
      if (img.naturalWidth > 0) markLoaded(img);
    });
  }

  // 遅延読み込みの画像はスケルトンを個別に消す必要があるため、capture で拾う
  document.addEventListener(
    'load',
    (event) => {
      const target = event.target;
      if (target.matches && target.matches(IMAGE_SELECTOR)) markLoaded(target);
    },
    true
  );

  // リスナを張る前に読み終わった画像と、Splide が複製したスライドを拾う
  sweep();
  window.addEventListener('load', sweep, { once: true });
  document.addEventListener('shopify:section:load', sweep);
})();
